var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionclose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94295 11.0911C10.2522 11.4004 10.7651 11.4004 11.0743 11.0911C11.3836 10.7819 11.3836 10.269 11.0743 9.95976L7.11457 6L11.0743 2.04024C11.3836 1.731 11.3836 1.21811 11.0743 0.90887C10.7651 0.599629 10.2522 0.599629 9.94296 0.90887L5.9832 4.86863L2.02336 0.908793C1.71412 0.599552 1.20123 0.599553 0.891991 0.908794C0.582749 1.21804 0.582748 1.73092 0.89199 2.04016L4.85182 6L0.89199 9.95983C0.582748 10.2691 0.582748 10.782 0.89199 11.0912C1.20123 11.4004 1.71412 11.4004 2.02336 11.0912L5.9832 7.13137L9.94295 11.0911Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionclose);
export default __webpack_public_path__ + "static/media/Unionclose.e10beeeb3696d4445113cef35e799042.svg";
export { ForwardRef as ReactComponent };